module.exports = __webpack_public_path__ + "static/assets/7ea9fdc7b4f02bc900f206308c0efe81.gif";